import { useEffect, useRef } from "react";

/**
 * Pledge Fundraiser Tracker (plg-goal widget).
 * Renders a progress bar of $ raised toward the campaign goal.
 * Uses the Pledge embed script that's already loaded from PledgeWidget for the donation form.
 */
const PARTNER_KEY = process.env.REACT_APP_PLEDGE_PARTNER_KEY || "49643c3ca563af31947ae957c8b8f713";
const ITEM_ID = process.env.REACT_APP_PLEDGE_TRACKER_ID || "460dd759a0ef34bdf529ed4e833ea733";

export default function PledgeTracker() {
  const ref = useRef(null);

  useEffect(() => {
    const rescan = () => {
      const plg = window.PledgeWidgets || window.pledge;
      try {
        if (plg && typeof plg.scan === "function") plg.scan();
      } catch (err) {
        console.warn("PledgeTracker: scan failed:", err);
      }
    };
    rescan();
    const t1 = setTimeout(rescan, 500);
    const t2 = setTimeout(rescan, 1400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (!PARTNER_KEY || !ITEM_ID) return null;

  return (
    <section data-testid="pledge-tracker-section" className="px-4 md:px-8 pt-6 md:pt-10 pb-2 max-w-4xl mx-auto">
      <div className="border-2 border-[#B32027] bg-white p-3 md:p-4">
        <p className="text-[#B32027] uppercase tracking-[0.3em] text-[10px] font-bold px-2 pt-2 pb-1">/ Campaign progress</p>
        <div
          ref={ref}
          data-testid="pledge-tracker"
          className="plg-goal"
          data-partner-key={PARTNER_KEY}
          data-item-id={ITEM_ID}
          data-show-donate-action="link"
        />
      </div>
    </section>
  );
}
